
  import React, { useState } from "react";
  import styled from "styled-components";
  import {
    StyledBox,
    CardTitle,
    CardText,

  } from "../../cards/card_componets";

  import {    
    DashLine,
    Badge,
    Badges,
    BadgeText,
    BadgeIcon,
    SolutionWrapper,
    SolutionContentsWrapper,} from "../solution/solution_components.js";

    import {FeeSolution} from "../solution/fee_solution.js";
    import {NumSolution,} from "../solution/num_solution.js";
  

export const Solution1Card = ({solutionNumber, title, text, src}) => (
    <StyledBox width="410" height="570" padding="0">
      <SolutionWrapper>
        <Badge color="#FDF3EE" borderColor="#EF8A57">
          <BadgeText fontColor="#EF8A57"> Solution {solutionNumber} </BadgeText>
        </Badge>
        <CardTitle marginTop="12">{title}</CardTitle>
        <CardText marginBottom="0">{text}</CardText>
        <DashLine />
        <FeeSolution/>
      </SolutionWrapper>
    </StyledBox>
);

export const Solution2Card = ({solutionNumber, title, text, src}) => (
    <StyledBox width="410" height="570" padding="0">
      <SolutionWrapper>
        <Badge color="#FDF3EE" borderColor="#EF8A57">
          <BadgeText fontColor="#EF8A57"> Solution {solutionNumber} </BadgeText>
        </Badge>
        <CardTitle marginTop="12">{title}</CardTitle>
        <CardText marginBottom="0">{text}</CardText>
        <DashLine />
        <NumSolution />
      </SolutionWrapper>
    </StyledBox>
);

export const Solution3Card = ({solutionNumber, title, text, src}) => (
    <StyledBox width="410" height="570" padding="0">
      <SolutionWrapper>
        <Badge color="#FDF3EE" borderColor="#EF8A57">
          <BadgeText fontColor="#EF8A57"> Solution {solutionNumber} </BadgeText>
        </Badge>
        <CardTitle marginTop="12">{title}</CardTitle>
        <CardText marginBottom="0">{text}</CardText>
        <DashLine />
        <SolutionContentsWrapper>
            컨텐츠 업데이트 예정입니다 T.T
        </SolutionContentsWrapper>
      </SolutionWrapper>
    </StyledBox>
);